import { message } from "antd";
import { MediaPurpose } from "@/utils/enum";
import { updateDocument } from "@/services/media";

export async function uploadGatePass(file) {
  if (!file.length === 0) {
    return;
  }

  try {
    const gatePassPayload = await updateDocument(file[0].originFileObj, MediaPurpose.GatePass);

    return gatePassPayload.url; // we only need the url
  } catch (error) {
    console.log(error);
    message.error("Something went wrong when trying to upload the gate pass, please try again later.");
    return;
  }
}
